/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/destination_canvas_notification_dismissed/:workflow_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId } from "./constants";
import type { GetEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdResult } from "./types";
import { isGetEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdResult } from "./validators";

export const getEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId = reactQueryFetcherAdapter(
  engagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowId,
  (
    signal: AbortSignal,
    { appGroupId, workflowId }: { appGroupId: string; workflowId: string }
  ): Promise<GetEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdResult> => {
    return fetch(
      `/engagement/${appGroupId}/destination_canvas_notification_dismissed/${workflowId}`,
      "GET",
      {},
      { signal }
    );
  },
  isGetEngagementAppGroupIdDestinationCanvasNotificationDismissedWorkflowIdResult
);
